<div class="container">

  <app-skip-to-content></app-skip-to-content>

  <app-header></app-header>

  <app-member-bar></app-member-bar>
  <!-- <app-breadcrumbs></app-breadcrumbs> -->

  <div class="row">
    <div class="col-lg-2">
    </div>
    <div class="col-lg-8 m-2">
      <alert role="alert" tabindex="0"></alert>
    </div>
    <div class="col-lg-2">
    </div>
  </div>

  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="rgb(50, 125, 156)" type="ball-scale-multiple">
    <p style="font-size: 20px; color: #fff">{{ 'COMMON.LOADING' | translate}}</p>
  </ngx-spinner>

  <router-outlet></router-outlet>

  <app-footer></app-footer>

</div>